var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignOut = function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    color: "#000"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.676 4.863a5.09 5.09 0 0 0-5.24-4.859H5.929A5.087 5.087 0 0 0 .638 4.863v15.262a5.087 5.087 0 0 0 5.29 4.87h5.558a5.09 5.09 0 0 0 5.19-4.87z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.077 11.54h12.604l-2.035-2.087a.954.954 0 0 1 0-1.348.94.94 0 0 1 1.348 0l3.727 3.714a.954.954 0 0 1 0 1.348l-3.803 3.714a.93.93 0 0 1-.674.28.94.94 0 0 1-.674-.28.954.954 0 0 1 0-1.348l2.099-2.086H8.077a.954.954 0 1 1 0-1.908"
  }))));
};
export default SvgSignOut;